export default __webpack_public_path__ + "static/media/J.b710cbb8.svg";